import {IError} from "@/models/models";

export interface StatisticsScreenState {
  columns: any;
  items: any;
  isLoading: boolean;
  error: IError;
}

const state = {
  items: [],
  isLoading: false,
  error: {
    message: ""
  } as IError
} as StatisticsScreenState;

export default state;
